import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=6e4c88bc&"
import script from "./Maintenance.vue?vue&type=script&lang=ts&"
export * from "./Maintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import ErrorPage from '@cnamts/vue-dot/src/templates/ErrorPage'
installComponents(component, {ErrorPage})
